// Money / Chit investments — money owed on a schedule (chit funds, private
// borrows) with repayment tracking. Sits alongside stock inventory (cars).
// Uses the main admin token (axiosInstance); backend is superadmin-gated.

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { MONEY } = API_ENDPOINTS;

export const moneyApi = {
  getList: (params = {}) => axiosInstance.get(MONEY.LIST, { params }),
  create: (data) => axiosInstance.post(MONEY.LIST, data),
  getDetail: (id) => axiosInstance.get(MONEY.DETAIL(id)),
  update: (id, data) => axiosInstance.patch(MONEY.DETAIL(id), data),
  remove: (id) => axiosInstance.delete(MONEY.DETAIL(id)),
  pay: (id, body) => axiosInstance.post(MONEY.PAY(id), body),
  removePayment: (id, paymentId) => axiosInstance.delete(MONEY.PAYMENT(id, paymentId)),
};
